/** WhatsApp AI messaging ships with AgentPhone (Twilio). Until then, hide live channel surfaces. */
export const WHATSAPP_CHANNEL_COMING_SOON = true;

export function isWhatsAppChannelLive(
  channels?: { whatsapp?: boolean } | null | undefined,
): boolean {
  if (WHATSAPP_CHANNEL_COMING_SOON) return false;
  return channels?.whatsapp === true;
}
